import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

export const ValidationPropType = PropTypes.shape({
  helperText: PropTypes.oneOfType([MessageDescriptorPropType, PropTypes.string]),
  helperTextType: PropTypes.string,
});
